<style scoped>

</style>
<template>
	<!-- <transition name="el-zoom-in-top"> -->
	<div class="content-wrapper">
		<section class="content">
			<div class="box">
				<div class="box-header with-border">
					<h3 class="box-title">All Direct Campaigns</h3>
				</div>
				<div class="box-body">
					<div class="clearfix">
						<router-link :to="`${'/admin/publisher/'+ this.$route.params.uuid +'/domain/'+ this.$route.params.domId + '/buckets/' + this.$route.params.bucketId + '/dc/add'}`" class="el-button el-button--info pull-right">
							<i class="el-icon-plus el-icon-left"></i>
							Create a Direct Campaign
						</router-link>
					</div>

					<el-table :data="directCampaigns" style="width: 100%;border-spacing: 0;">
						<el-table-column type="expand">
							<template scope="props">
								<p>Campaign Name: {{ props.row.advertiser.advertiser_name }}</p>
								<p>Cost Type: {{ props.row.line_item.cost_type }}</p>
								<p>Line Item Type: {{ props.row.line_item.line_item_type }}</p>
								<p>Primary Goal Unit Type: {{ props.row.line_item.primary_goal_unit_type }}</p>
								<span>Creatives: </span><p v-html = "props.row.creatives.creative "></p>

							</template>
						</el-table-column>
						<el-table-column label="" width="50">
							<template slot-scope="scope">
								<div class="text-center">
									<img class="round" width="30" height="30" :avatar="`${scope.row.advertiser.advertiser_name}`">
								</div>
							</template>
						</el-table-column>
						<el-table-column width="300" label="" prop="advertiser.advertiser_name"></el-table-column>
						<el-table-column width="300" label="">
							<template scope="props">
								<p> {{ new Date( props.row.line_item.start_date).toLocaleString() }}</p>
							</template>
						</el-table-column>
						<el-table-column width="300" label="">
							<template scope="props">
								<p> {{ new Date( props.row.line_item.end_date).toLocaleString() }}</p>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
		</section>
	</div>
	<!-- </transition> -->
</template>
<script type="text/javascript">
	import axios from 'axios';
	import LetterAvatar from '../../../../static/plugins/letterAvatar.js'
	export default {
		data() {
			return {
				directCampaigns: []
			};
		},
		created: function(){
			axios.all([
				axios.get(BASE_URL + 'v1/publishers/' + this.$route.params.uuid + '/domains/' + this.$route.params.domId + '/direct-campaigns/')
			])
			.then(axios.spread( response =>  {
				this.directCampaigns = response.data;
					window.setTimeout(function(){
					LetterAvatar.transform();
				});

			}));
		}
	};
</script>


// WEBPACK FOOTER //
// AllDirectCampaign.vue?3ec9f577